<template>
  <div id="model">
    <div>
      <div ref="cover" class="cover"></div>
      <div ref="allModel" class="allModel">
        <div :style="{'width':minWidth === undefined || minWidth === null ?'800px':minWidth}" class="content">
          <div class="modelHead t_c p_r d_flex">
            <i class="icon iconfont iconguanbi " style="font-size: 18px;visibility: hidden"></i>
            <span class="font18 f_w">{{title === undefined || title === null ? '': title}}</span>
            <i @click="cancelModel()" class="icon iconfont iconguanbi  " style="font-size: 18px;" :style="{'visibility': showClose !== 1 ? '' : 'hidden'}"></i>
          </div>
          <!--<div class="modelBody">-->
          <div class="allModelPlace">
            <slot>
              没内容
            </slot>
          </div>
          <div class="modelFoot">
            <div v-if="OnButton === 0">
            </div>
            <div v-if="OnButton === 1">
              <button @click="cancelModel()" class="cancelButton  m_r_10"><span>取消</span></button>
              <button @click="confirmModel()" class="suerButton m_r_20 "><span>确定</span></button>
            </div>
            <div v-if="OnButton === 2">
              <button @click="confirmModel()" class="suerButton m_r_10 m_l_10"><span>确定</span></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'model',
  props: [
    'onButton',
    'minWidth',
    'fromUser',
    'title',
    'showModel',
    'showClose'
  ],
  data () {
    return {
      OnButton: parseInt(this.onButton)
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    const that = this
    setTimeout(function () {
      if (that.$refs && that.$refs.cover && that.$refs.allModel) {
        that.$refs.cover.style.opacity = 1
        that.$refs.allModel.style.opacity = 1
        that.$refs.allModel.style.top = '0px'
      }
    }, 10)
  },
  methods: { // 所有的方法封装
    cancelModel () {
      const that = this
      that.$refs.cover.style.opacity = 0
      that.$refs.allModel.style.opacity = 0
      that.$refs.allModel.style.top = '-100px'
      setTimeout(function () {
        that.$emit('on-cancel', '')
      }, 500)
    },
    confirmModel () {
      this.$emit('on-confirm', '')
    },
    confirmModel2 () {
      this.$emit('on-confirm2', '')
    },
    conTwoModel () {
      this.$emit('on-confirmTwo', '')
    }
  },
  components: {
  },
  watch: {
    onButton (val) {
      this.OnButton = parseInt(val)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/myComponents/model.vue